export const STRINGS = {
  en: {
    launcher: "Ask Ceres",
    title: "Ceres",
    subtitle: "Information assistant",
    welcome: "Hi, I'm Ceres, Harvest's fund guide. Ask me about any Harvest ETF or Harvest High Income Shares™ fund: yields, distributions, strategies, documents and our latest research.",
    welcomeHhis: "Hi, I'm Ceres. Ask me about any Harvest High Income Shares™ ETF: single-stock and all-in-one funds, monthly distributions, leverage and documents.",
    noticeHhis: "I share information about Harvest High Income Shares™. I can't give personal investment advice.",
    moreIdeas: "More ways I can help",
    expand: "Open Ceres full page",
    mic: "Ask by voice",
    micStop: "Stop recording and send",
    listening: "Listening… tap to send",
    transcribing: "Transcribing…",
    micError: "Couldn't hear that. Please try again or type your question.",
    share: "Copy share link",
    brief: "Download advisor brief (PDF)",
    voiceMode: "Voice mode",
    vmListening: "Listening…",
    vmTranscribing: "Got it…",
    vmThinking: "Ceres is thinking…",
    vmSpeaking: "Ceres is speaking. Just talk to interrupt",
    vmIdle: "Tap the orb to talk",
    vmTalk: "Talk",
    vmEnd: "End voice mode",
    vmHint: "Talk naturally. Ceres answers out loud, and you can cut in anytime. Headphones work best. Information only, not investment advice.",
    listen: "Listen to this answer",
    stopListening: "Stop reading",
    speaking: "Ceres is reading the answer",
    preparingVoice: "Preparing voice…",
    stopVoice: "Stop",
    shared: "Share link copied",
    finder: "Fund Finder",
    finderIntro: "Three neutral questions to filter Harvest funds by published facts. This is not advice.",
    finderSteps: [
      ["What do you want to look at?", [["income", "Funds that pay regular distributions", "Monthly, twice-monthly or quarterly"], ["growth", "Growth-focused funds", "Distributions annually, if any"], ["mix", "One-ticket portfolios", "All-in-One and asset allocation funds"], ["any", "Show me everything", ""]]],
      ["Which exposure interests you?", [["broad", "Sectors and broad equity", "Healthcare, tech, utilities, US and Canadian leaders"], ["single", "Single companies", "Harvest High Income Shares™"], ["fixed", "Fixed income", "Bond and treasury strategies"], ["digital", "Digital assets", "Bitcoin and Ethereum"], ["any", "No preference", ""]]],
      ["Which risk rating range?", [["low", "Low to Low-to-Medium", ""], ["medium", "Medium", ""], ["high", "Medium-to-High or High", ""], ["any", "Any risk rating", ""]]],
    ],
    finderNext: "Next",
    finderBack: "Back",
    finderShow: "Show funds",
    finderCancel: "Close",
    finderStep: (i, n) => `Step ${i} of ${n}`,
    finderResult: (n, labels) => `${n} Harvest ${n === 1 ? "fund matches" : "funds match"} your filters: ${labels.join(" · ")}.`,
    finderNone: "No Harvest fund matches all three filters. Try widening one of them.",
    audiences: [
      ["New to investing", ["What is a covered call ETF, in plain English?", "How do I buy a Harvest ETF?", "What does current yield mean?", "How are Harvest distributions taxed?"]],
      ["Advisors & pros", ["Compare HHL, HHLE and HHL.U", "Which Enhanced funds use leverage and at what cost?", "Show monthly payers sorted by yield with risk ratings", "Link the ETF Facts and prospectus for HMAX"]],
      ["Existing investors", ["When is the next HHIS distribution paid?", "What happened to Harvest Brand Leaders Plus?", "Where is my 2025 tax summary?", "What's new from Harvest this month?"]],
    ],
    welcomeTicker: (t) => `Ask me anything about ${t}.`,
    notice: "I share information about Harvest ETFs. I can't give personal investment advice.",
    chips: ["Compare two ETFs", "Which funds pay monthly?", "Explain covered calls", "Latest Harvest research"],
    placeholder: "Ask about a Harvest fund…",
    send: "Send",
    close: "Close chat",
    expand: "Open full screen",
    thinking: "Looking that up",
    copy: "Copy answer",
    copied: "Copied",
    up: "Helpful",
    down: "Not helpful",
    thanks: "Thanks for the feedback",
    sources: "Sources",
    fundPage: "Fund page",
    etfFacts: "ETF Facts",
    privacy: "Please don't share names, emails or account details.",
    endOfDay: "end-of-day",
    asAt: "As at",
    price: "Market price",
    nav: "NAV",
    yield: "Current yield",
    lastDist: "Last distribution",
    freq: "Frequency",
    aum: "AUM",
    risk: "Risk rating",
    fee: "Mgmt. fee",
    perf: "Annualized returns",
    pastPerf: "Past performance may not be repeated.",
    newChat: "New chat",
    funds: "funds",
  },
  fr: {
    launcher: "Demandez à Ceres",
    title: "Ceres",
    subtitle: "Assistant d'information",
    welcome: "Bonjour, je suis Ceres, le guide des fonds Harvest. Posez-moi vos questions sur les FNB Harvest et les Harvest High Income Shares™ : rendements, distributions, stratégies, documents et nos dernières recherches.",
    welcomeHhis: "Bonjour, je suis Ceres. Posez-moi vos questions sur les FNB Harvest High Income Shares™ : fonds à titre unique et tout-en-un, distributions mensuelles, effet de levier et documents.",
    moreIdeas: "D'autres façons de vous aider",
    expand: "Ouvrir Ceres en pleine page",
    mic: "Poser une question à voix haute",
    micStop: "Arrêter et envoyer",
    listening: "À l'écoute… touchez pour envoyer",
    transcribing: "Transcription…",
    micError: "Je n'ai pas bien entendu. Réessayez ou tapez votre question.",
    share: "Copier le lien de partage",
    brief: "Télécharger la note conseiller (PDF)",
    listen: "Écouter cette réponse",
    stopListening: "Arrêter la lecture",
    speaking: "Ceres lit la réponse",
    preparingVoice: "Préparation de la voix…",
    stopVoice: "Arrêter",
    shared: "Lien copié",
    audiences: [
      ["Nouveaux investisseurs", ["Qu'est-ce qu'un FNB d'options d'achat couvertes?", "Comment acheter un FNB Harvest?", "Que signifie le rendement courant?", "Comment les distributions sont-elles imposées?"]],
      ["Conseillers et professionnels", ["Comparer HHL, HHLE et HHL.U", "Quels fonds Enhanced utilisent l'effet de levier?", "Fonds mensuels triés par rendement avec cote de risque", "Aperçu du FNB et prospectus de HMAX"]],
      ["Investisseurs actuels", ["Quand la prochaine distribution de HHIS est-elle versée?", "Qu'est-il arrivé à Harvest Brand Leaders Plus?", "Où trouver le sommaire fiscal 2025?", "Quoi de neuf chez Harvest ce mois-ci?"]],
    ],
    welcomeTicker: (t) => `Posez-moi vos questions sur ${t}.`,
    notice: "Je fournis de l'information sur les FNB Harvest. Je ne peux pas donner de conseils de placement personnalisés.",
    chips: ["Comparer deux FNB", "Quels fonds versent chaque mois?", "Expliquer les options d'achat couvertes", "Dernières recherches Harvest"],
    placeholder: "Posez une question sur un fonds Harvest…",
    send: "Envoyer",
    close: "Fermer le clavardage",
    expand: "Plein écran",
    thinking: "Recherche en cours",
    copy: "Copier la réponse",
    copied: "Copié",
    up: "Utile",
    down: "Pas utile",
    thanks: "Merci de votre rétroaction",
    sources: "Sources",
    fundPage: "Page du fonds",
    etfFacts: "Aperçu du FNB",
    privacy: "Veuillez ne pas partager de noms, courriels ou renseignements de compte.",
    endOfDay: "fin de journée",
    asAt: "Au",
    price: "Cours du marché",
    nav: "VL",
    yield: "Rendement courant",
    lastDist: "Dernière distribution",
    freq: "Fréquence",
    aum: "ASG",
    risk: "Cote de risque",
    fee: "Frais de gestion",
    perf: "Rendements annualisés",
    pastPerf: "Le rendement passé pourrait ne pas se reproduire.",
    newChat: "Nouvelle conversation",
    funds: "fonds",
  },
};

export const t = (lang) => STRINGS[lang] || STRINGS.en;
